// Pure: pick the active, unassigned leads from both pipelines, combined and
// sorted oldest-first. No React, no Firestore. (Eligibility mirrors the lead
// rules in duplicateLeads.js / statusSheetData.js — kept local to stay
// decoupled from those modules.)

const RESOLVED = ["won", "lost", "converted"];
const notDeleted = (x) => !x?.deletedAt && x?.deleted !== true;
const isActive = (x) => {
  const s = String(x?.status || "active").toLowerCase();
  return !RESOLVED.includes(s) && !x?.convertedDealId;
};
// Unassigned = no PRIMARY assignedAgent. A co-agent alone doesn't count.
const unassigned = (x) => !x?.assignedAgent;

function rowsFrom(leads, pipeline, collection) {
  return (leads || [])
    .filter((l) => notDeleted(l) && isActive(l) && unassigned(l))
    .map((l) => ({ ...l, pipeline, collection }));
}

export function selectUnassignedLeads({ listingLeads = [], buyerLeads = [] } = {}) {
  const rows = [
    ...rowsFrom(listingLeads, "listing", "listing_leads"),
    ...rowsFrom(buyerLeads, "buyer", "buyer_leads"),
  ];
  return rows.sort((a, b) => Number(a.createdAt || 0) - Number(b.createdAt || 0));
}
